/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Incident severity level
 */
export type UpdateIncidentRuleDtoSeverity = (typeof UpdateIncidentRuleDtoSeverity)[keyof typeof UpdateIncidentRuleDtoSeverity];

export const UpdateIncidentRuleDtoSeverity = {
  MINOR: 'minor',
  MAJOR: 'major',
  CRITICAL: 'critical',
} as const;
